import { requireStringEnvVar } from "../../config";
import { getImpersonatedPersonId } from "../local-storage/impersonated-person";
import { getPreferredLanguage } from "../local-storage/language";
import { getOrganizationId } from "../local-storage/selected-organization";

export interface BffRequest {
  method?: "GET" | "POST";
  body?: string;
  headers?: Record<string, string>;
}

export const fetchBffBlob = async (path: string, request: BffRequest = {}): Promise<Blob> => {
  const organizationId = getOrganizationId();
  const personId = getImpersonatedPersonId();
  const url = path.startsWith("http") ? path : `${requireStringEnvVar("VITE_BFF_BASE_URL")}${path}`;
  const response = await fetch(url, {
    method: request.method ?? "GET",
    body: request.body,
    credentials: "include",
    headers: {
      ...(organizationId ? { organizationId } : undefined),
      ...(personId ? { personId } : undefined),
      "preferred-language": getPreferredLanguage(),
      ...request.headers,
    },
  });
  if (!response.ok) throw new Error(`Download of ${path} failed with ${response.status}`);
  return response.blob();
};

export const saveBlob = (blob: Blob, fileName: string) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    window.URL.revokeObjectURL(objectUrl);
  }
};

export const downloadBffFile = async (path: string, fileName: string, request?: BffRequest) =>
  saveBlob(await fetchBffBlob(path, request), fileName);

export const jsonPost = (payload: unknown): BffRequest => ({
  method: "POST",
  body: JSON.stringify(payload),
  headers: { "Content-Type": "application/json" },
});
